let Vue = require('vue');
let Vuex = require('vuex');
import { vueFactory } from '../../factories/vue';
import App from './../../components/search/property-results.vue';

Vue.use(Vuex);
Vue.component('favorite-button', require('./../../components/ad/favorite-button/favorite-button.vue').default);
Vue.component('pagination', require('./../../components/pagination/pagination.vue').default);

const store = new Vuex.Store({
    state: {
        page_title: '',
        type: 'rooms',
        location: '',
        city_name: '',
        sign: '',
        ads: [],
        pagination: {},
        district: [],
        districts: [],
        sort: 'relevant',
        amenities: [],
        filter: {
            room_type: 'todos',
            gender: '',
            price_range: [0, 15000],
            has_photo: false,
            smokers_allowed: false,
            children_allowed: false,
            pets_allowed: false,
            drinks_allowed: false,
            amenities: [],
        },
    },
    getters: {
        getPageTitle: function (state) {
            return state.page_title;
        },
        getType: function (state) {
            return state.type;
        },
        getLocation: function (state) {
            return state.location;
        },
        getFilter(state) {
            return state.filter;
        },
        getGender(state) {
            return state.filter.gender;
        },
        getRoomType(state) {
            return state.filter.room_type;
        },
        getAds: function (state) {
            return state.ads;
        },
        getPagination: function (state) {
            return state.pagination;
        },
        getSort: function (state) {
            return state.sort;
        },
        getAmenities: function (state) {
            return state.amenities;
        },
        getDistrict: function (state) {
            return state.district;
        },
        getDistricts: function (state) {
            return state.districts;
        },
    },
    mutations: {
        setPageTitle: function (state, title) {
            state.page_title = title;
        },
        setCityName: function (state, city) {
            state.city_name = city;
        },
        setCurrencySign: function (state, sign) {
            state.sign = sign;
        },
        setAds: function (state, ads) {
            state.ads = ads;
        },
        setType: function (state, type) {
            state.type = type;
            let ad_types = ['entire-spaces', 'shared-rooms', 'single-rooms'];
            if (ad_types.includes(type))
                this.commit('setFilter', {'room_type': type});
        },
        setFilter(state, obj) {
            for (const key in obj) {
                if (state.filter.hasOwnProperty(key)) {
                    let value = obj[key];

                    if (key == 'price_range') {
                        if (Array.isArray(value) && value.length == 1)
                            value = value[0].split(',');

                        if (value == null)
                            continue;
                    }

                    if (key == 'amenities') {
                        if (Array.isArray(value)) {
                            if ((value[0])) {
                                let arr = value[0].split(',');
                                value = arr.filter(function (i) { return i; });
                            } else
                                continue;
                        } else
                            value = [value].filter(function (i) { return i; });
                    }


                    Vue.set(state.filter, key, value);
                }
            }
        },
        setLocation: function (state, location) {
            state.location = location;
        },
        setDistrict: function (state, district) {
            if (!Array.isArray(district)) {
                district = district.split('|');
            }
            state.district = district;
        },
        setPagination: function (state, obj) {
            state.pagination = obj;
        },
        setSort: function (state, sort) {
            state.sort = sort;
        },
        setAmenities: function (state, amenities) {
            state.amenities = amenities;
        },
        setDistricts: function (state, districts) {
            state.districts = districts;
        }
    },
});

export default vueFactory({
    store,
    render: h => h(App),
});
